import InputAutocomplete from '../InputAutocomplete';
import TextAreaAutocomplete from '../TextAreaAutocomplete';
import CheckBox from '../CheckBox';

export default {
  '0': {
    label: 'Mail to Vendor',
    placeholder: '',
    system: {
      name: 'checkbox',
      component: CheckBox,
    },
    value: false,
    errors: [],
    type: 'checkbox',
    name: 'checkbox',
    rules: {}
  },
  '1': {
    label: 'Emails',
    placeholder: 'Add email list',
    system: {
      name: 'input',
      component: InputAutocomplete,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'input',
    rules: {
      title: 'Email list field',
      required: true,
    }
  },
  '2': {
    label: 'Supplies',
    placeholder: 'Add supplie',
    system: {
      name: 'textfield',
      component: TextAreaAutocomplete,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'textfield',
    rules: {
      title: 'Supplies field',
      required: true,
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/SuppliesLog/fields.js